import { parseDownloadLink } from './downloadLinkBaseParser';
import { type TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';

class DownloadLinkTagParser implements TagParser {
  tag = 'downloadlink_start';

  parse(text: string) {
    const endTag = 'downloadlink_end';
    return parseDownloadLink(text, endTag);
  }
}

ParserRegistry.register(new DownloadLinkTagParser());
